import * as Yup from 'yup';

import { VALIDATIONS_ERROR } from '~constants/index';

import { DialogRebilOrdersMode } from './types';

export const FIELDS_NAME = {
  MODE: 'mode',
  AMOUNT: 'amount',
};

export const isAutomaticMode = (currentMode?: DialogRebilOrdersMode): boolean =>
  currentMode === 'automatic';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (excludeMode?: DialogRebilOrdersMode) => ({
  [FIELDS_NAME.MODE]: isAutomaticMode(excludeMode) ? 'manual' : 'automatic',
  [FIELDS_NAME.AMOUNT]: '',
});

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.MODE]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.AMOUNT]: Yup.string().when(FIELDS_NAME.MODE, {
    is: (mode: DialogRebilOrdersMode) => !isAutomaticMode(mode),
    then: (schema) => schema.required(VALIDATIONS_ERROR.REQUIRED),
    otherwise: (schema) => schema.notRequired(),
  }),
});
